<template lang="pug">
div(v-if="dataReady")
	h3 Billing Information
	card-form(:data="card", :isCheckout="isCheckout")

	div(style="display: flex;")
		div(v-for="contact in contacts", style="width: 50%;")
			h3 {{ contact.title }}
			person(:data="contact.object", :is-valid="validContacts[contact.object.typeId]" :isCheckout="isCheckout", :isRequired="isRequired")

	.div-container-right
		a(@click="previous")
			easyBtn(btnText="Previous")
		a(@click="next")
			easyBtn(btnText="Next")
</template>

<script>
import store from 'CommonApp/store'
import CardForm from './card-form.vue'
import Person from 'Common/components/party/person.vue'
import { mapActions } from 'vuex'
import _ from 'lodash'
import easyBtn from 'Common/components/easy-btn.vue'

export default {
	components: { Person, CardForm, easyBtn },
	name: 'checkout-billing',
	props: ['products', 'card', 'contacts'],
	data () {
		return {
			dataReady: false,
			validContacts: {},
			isCheckout: false,
			isRequired: true
		}
	},
	mounted () {
		// console.log('mounted inside component is ready')
		this.handler()
		console.debug('validContacts ', this.validContacts)
	},
	watch: {
		// Watch contacts for its change and create validation object
		contacts: {
			handler () {
				this.contacts.map((contact) => {
					this.validContacts[contact.object.typeId] = {
						result: true
					}
				})
				this.dataReady = true
			}
		}
	},
	methods: {
		handler () {
			this.contacts.map((contact) => {
				this.validContacts[contact.object.typeId] = {
					result: true
				}
			})
			this.dataReady = true
		},
		...mapActions(['addToCart', 'clearCart']),

		next () {
			console.log('card', this.card)
			this.isCheckout = true
			if (!this.card.cardNumber) {
				// Show order not found error
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Card error',
					text: 'Card number required',
					duration: 5000
				})
				return
			} else if (!this.card.expireMonth) {
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Card error',
					text: 'Expire month required',
					duration: 5000
				})
				return
			} else if (!this.card.expireYear) {
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Card error',
					text: 'Expire year required',
					duration: 5000
				})
				return
			} else if (!this.card.nameOnCard) {
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Card error',
					text: 'Name on card required',
					duration: 5000
				})
				return
			} else if (!this.card.cvv) {
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Card error',
					text: 'CVV2/CVC2 value from the card is required',
					duration: 5000
				})
				return
			}

			let invalidContactFound = false
			this.contacts.forEach((contact) => {
				if (!this.validContacts[contact.object.typeId].result) {
					invalidContactFound = true
					this.$notify({
						group: 'app',
						type: 'error',
						title: 'Contact error',
						text: 'Please complete required contact information',
						duration: 3000
					})

					if (!this.validContacts[contact.object.typeId].address) {
						this.$notify({
							group: 'app',
							type: 'error',
							title: 'Missing address',
							text: 'Please complete missing contact address',
							duration: 3000
						})
					} else if (!this.validContacts[contact.object.typeId].email) {
						this.$notify({
							group: 'app',
							type: 'error',
							title: 'Missing Email',
							text: 'Please complete missing contact email',
							duration: 3000
						})
						// E24-35: was a bare `if`, not `else if`, so the phone
						// check always ran independently of address/email
						// instead of being mutually exclusive with them like
						// the rest of this chain.
					} else if (!this.validContacts[contact.object.typeId].phone) {
						this.$notify({
							group: 'app',
							type: 'error',
							title: 'Missing phone',
							text: 'Please complete missing contact phone',
							duration: 3000
						})
					}
				}
			})

			if (!invalidContactFound) {
				this.clearCart()

				_.map(this.products, (product) => {
					if (product.checked) {
						this.addToCart(product)
					}
				})

				store.dispatch({
					type: 'changeCheckoutActiveTab',
					value: 'review-order'
				})
			}
		},
		previous () {
			store.dispatch({
				type: 'changeCheckoutActiveTab',
				value: 'tab-delivery-options'
			})
		}
	}
}
</script>

<style lang="less">
.errorContactLabel {
	color: red;
}
</style>



// WEBPACK FOOTER //
// src/app/checkout/tabs-components/billing.vue